const pad = (n: number) => String(n).padStart(2, "0");

export function isoToDatetimeLocal(iso: string | null | undefined): string {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function datetimeLocalToIso(value: string): string {
  return new Date(value).toISOString();
}

export function formatDatetimeLocalLabel(value: string): string | null {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

// Ex.: `2026-07-16T02:00:00.000Z` em UTC-3 = `2026-07-15 23:00 local`
// → retorna `"2026-07-15"` (não `"2026-07-16"`).
export function isoToDateLocal(iso: string | null | undefined): string {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

// Interpreta como MEIA-NOITE no fuso LOCAL. Sem isso, `T00:00:00Z`
// enviaria meia-noite UTC = dia anterior em fusos negativos (UTC-3 BR).
export function dateLocalToIso(value: string): string {
  return new Date(`${value}T00:00:00`).toISOString();
}

export function dateLocalToIsoEndOfDay(value: string): string {
  return new Date(`${value}T23:59:59.999`).toISOString();
}

export function dateToLocalDateString(date: Date): string {
  if (Number.isNaN(date.getTime())) return "";
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
